import { Component, OnInit } from '@angular/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
	selector: 'cv-custom-status-cell',
	templateUrl: './custom-status-cell.component.html',
	styleUrls: ['./custom-status-cell.component.scss']
})
export class CustomStatusCellComponent implements ICellRendererAngularComp {
	public cellValue: any;
	isGSE: boolean;

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
		this.isGSE = this.cellValue.statusReason === 'GSEValidation';
	}
	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}
}
